import { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import API from '../../api/api'
import {
  setValetSettings,
  setTicketData,
  setServiceFee,
  setBuildingData,
} from '../../reducers/parkingReducer'

import ParkingVehicleInfo from './ParkingVehicleInfo'
import ParkingGuestHeader from './ParkingGuestHeader'
import ParkingServicesShortInfo from './ParkingServicesShortInfo'

const ParkingGuestInfo = ({
  setValetSettingsStore,
  setTicketDataStore,
  ticketData,
  valetSettings,
  setServiceFeeStore,
  buildingData,
  setBuildingDataStore,
}) => {
  const { t } = useTranslation(['parking'])
  const { ticketNumber } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    ;(async () => {
      try {
        const resp = await API.getParkingTicket(ticketNumber)
        setTicketDataStore(resp.data)
      } catch {
        navigate('/parking/error/404')
      }
    })()
  }, [ticketNumber])

  useEffect(() => {
    ;(async () => {
      try {
        const resp = await API.calculateParkingFee(ticketNumber)
        setServiceFeeStore(resp.data.serviceFee)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [ticketNumber])

  useEffect(() => {
    ;(async () => {
      if (ticketData.buildingId) {
        try {
          const resp = await API.getSingleBuilding(ticketData.buildingId)
          setBuildingDataStore(resp)
        } catch (error) {
          console.error(error)
        }
      }
    })()
  }, [ticketData.buildingId])

  useEffect(() => {
    ;(async () => {
      if (ticketData.buildingId) {
        try {
          const resp = await API.getValetSettings(ticketData.buildingId)
          setValetSettingsStore(resp.data)
        } catch (error) {
          console.error(error)
        }
      }
    })()
  }, [ticketData.buildingId])

  useEffect(() => {
    if (ticketData.status && ticketData.status !== 'checked-in') {
      if (ticketData.paid || !valetSettings.paymentRequired) {
        navigate(`/parking/${ticketNumber}/summary`)
      } else {
        navigate(`/parking/${ticketNumber}/payment`)
      }
    }
  }, [ticketData.status])

  const vehicleData = {
    plate: ticketData.licensePlate,
    color: ticketData.color,
    make: ticketData.make,
    model: ticketData.model,
    phone: ticketData.phone,
  }

  const ticketShortData = {
    startTime: ticketData.startDate,
    timezone: buildingData.timezone,
    ticketNumber: ticketData.ticketNumber,
    costSettings: valetSettings.pricing,
  }

  const handleRequestVehicle = () => {
    navigate(`/parking/${ticketNumber}/services-info`)
  }

  return (
    <div className="parking-info">
      <ParkingGuestHeader buildingName={buildingData.name} />
      <ParkingVehicleInfo vehicleData={vehicleData} />
      <ParkingServicesShortInfo data={ticketShortData} />
      <button
        type="submit"
        data-testid="submit"
        onClick={handleRequestVehicle}
        className="button button-black parking-info__submit-button"
      >
        {t('parking:requestVehicle')}
      </button>
    </div>
  )
}

ParkingGuestInfo.propTypes = {
  setValetSettingsStore: PropTypes.func,
  setTicketDataStore: PropTypes.func,
  ticketData: PropTypes.object,
  valetSettings: PropTypes.object,
  serviceFee: PropTypes.number,
  setServiceFeeStore: PropTypes.func,
  buildingData: PropTypes.object,
  setBuildingDataStore: PropTypes.func,
}

export default connect(
  (state) => ({
    ticketData: state.parking.ticketData,
    valetSettings: state.parking.valetSettings,
    serviceFee: state.parking.serviceFee,
    buildingData: state.parking.buildingData,
  }),
  {
    setValetSettingsStore: setValetSettings,
    setTicketDataStore: setTicketData,
    setServiceFeeStore: setServiceFee,
    setBuildingDataStore: setBuildingData,
  },
)(ParkingGuestInfo)
